import Inspirado from '../images/inspirado.png';
import Hapkido from '../images/hapkido.png';
import Quince from '../images/once.png';
import Jasmine from '../images/jasmine.png';
import Loyola from '../images/loyola.png';

export const clientsData = [
  {
    id: 1,
    title: 'Inspirado Fragrances',
    category: 'Client Website • E-commerce',
    img: Inspirado,
    description:
      'Designed and built the Inspirado Fragrances website, handling all creative direction, branding concepts, and UI/UX. Developed on Shopify with custom HTML and CSS to support a luxury fragrance brand.',
    websiteLink: 'https://inspiradofragrances.com/',
    tech: 'Shopify • HTML • CSS • Brand Design',
  },
  {
    id: 2,
    title: 'Song’s Hapkido WLA',
    category: 'Client Website',
    img: Hapkido,
    description:
      'Designed and developed a website for Song’s Hapkido WLA to showcase classes, philosophy, and training information. Focused on clarity, accessibility, and mobile responsiveness.',
    websiteLink: 'https://songshapkidowla.com/', // update if different
    tech: 'Web Design • Responsive Layout • Client-Focused UX',
  },
  {
    id: 3,
    title: 'Once in a Lifetime Quinceañera',
    category: 'Client Website • Branding',
    img: Quince,
    description:
      'Created a website and brand presence for Once in a Lifetime Quinceañera, highlighting services, choreography offerings, and event coordination. Emphasized storytelling, empowerment, and cultural identity.',
    websiteLink: 'https://onceinalifetime15.com/', // update if different
    tech: 'Web Design • Branding • Content Strategy',
  },
  {
    id: 4,
    title: 'Jasmine Lopez Photography',
    category: 'Client Portfolio Website',
    img: Jasmine,
    description:
      'Designed a photography portfolio website for Jasmine Lopez, focusing on visual storytelling, clean layouts, and image-forward design to highlight her work.',
    websiteLink: 'https://www.jas-lo.com/', 
    tech: 'Portfolio Design • UX/UI • Visual Layout',
  },
  {
    id: 5,
    title: 'Loyola Water Polo Club',
    category: 'Client Website • Branding • Social Media',
    img: Loyola,
    description:
      'Led web design, branding, and digital presence for Loyola Water Polo Club. Manage social media strategy, designed apparel + brand identity, and developed visual assets to strengthen brand identity and community engagement.',
    websiteLink: 'https://loyolawpclub.com/', 
    tech: 'Web Design • Branding • Apparel Design • Social Media',
  },
];
